export function getAccountTypeKey(cognitoId: string) {
  return `${cognitoId}:accountType`;
}

export const PARTNER_CODE_KEY = 'partnerCode';
